module.exports = __webpack_public_path__ + "img/kleisma1.12d43561.webp";